import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/customer-portal/")({
  beforeLoad: () => {
    throw redirect({
      to: "/",
    });
  },
});
